import React from 'react';
import CrudPage from '../../components/CrudPage';
import { tannitIdsApi } from '../../services/adminApi';

const columns = [
  { header: 'ID', field: 'id' },
  { header: 'Tannit ID', field: 'tannitId' },
  { header: 'Type', field: 'type' },
  { header: 'Reference ID', field: 'referenceId' },
  { header: 'Created', field: 'createdAt', type: 'date' },
];

const formFields = [
  { name: 'tannitId', label: 'Tannit ID', type: 'text', required: true },
  { name: 'type', label: 'Type', type: 'text' },
  { name: 'referenceId', label: 'Reference ID', type: 'text' },
];

const TannitIdsPage = () => (
  <CrudPage
    title="Tannit IDs"
    subtitle="Manage Tannit ID mappings"
    api={tannitIdsApi}
    columns={columns}
    formFields={formFields}
    idField="id"
    searchField="tannitId"
  />
);

export default TannitIdsPage;
